import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { NgxTgModule } from '@worthy-ventures/metaglotta-ngx';

@Component({
  selector: 'app-about-us',
  imports: [MenuBarComponent, FooterComponent, NgxTgModule],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  constructor(private router: Router) {}

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  goToUrl(url: string): void {
    this.router.navigate(['/' + url]);
  }
}
